export var MessageTrace;
(function (MessageTrace) {
    /**
     * Defined in:
     *   {@link file://./../../dxos/rpc.proto}
     */
    let Direction;
    (function (Direction) {
        Direction[Direction["INCOMING"] = 0] = "INCOMING";
        Direction[Direction["OUTGOING"] = 1] = "OUTGOING";
    })(Direction = MessageTrace.Direction || (MessageTrace.Direction = {}));
})(MessageTrace || (MessageTrace = {}));
//# sourceMappingURL=rpc.js.map